import { BANK_PAYMENT_RETURN_TRANSACTION_REQUEST, GET_BANK_PAYMENT_RETURN_TRANSACTIONS, BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE } from '../types';

const initialState = {
  bankPaymentReturnTransactions: [],
  loading: false,
  error: null,
};

const bankPaymentReturnTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_PAYMENT_RETURN_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_PAYMENT_RETURN_TRANSACTIONS: {
      return {
        ...state,
        bankPaymentReturnTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankPaymentReturnTransactionReducer;